import { Spinner } from "@nike/eds";

export const TableSpinner = () => (
    <div className="noDataText">
      <Spinner data-testid="spinner" className="eds-spacing--mt-8 eds-spacing--mb-8" size='large' />
    </div>
);